import React from "react";
import LeftPanel from "../left-panel/left-panel";
import Header from "../header/header";
import { BodyText, NormalText, PageHeader } from "../title-container/LText";
import { useDispatch, useSelector } from "react-redux";
import { pannelClose, pannelOpen } from "../../../store/model/model.action";
import { ArrowLeftIcon } from "@forge/common";

interface HeaderProps {
  title?: string;
  children?: React.ReactNode;
  headerRight?: React.ReactNode;
  disableNavigation?: boolean;
}

const PanelContainer: React.FC<HeaderProps> = ({ title, children, headerRight, disableNavigation = false }) => {
  const dispatch = useDispatch();
  const { pannelStatus } = useSelector((state: any) => state?.modalReducer || {});

  const handleClickHam = () => {
    if (pannelStatus) {
      dispatch(pannelClose());
    } else {
      dispatch(pannelOpen());
    }
  };

  return (
    <div className="h-full flex">
      <div className="h-full">
        <LeftPanel showLeftPanel={pannelStatus} disableNavigation={disableNavigation} />
      </div>
      <div className="w-full text-white px-4 pb-4">
        <div className="mt-3">
          <Header handleClickHam={handleClickHam} />
        </div>
        <div
          className="application-dark h-[calc(100vh)] overflow-hidden flex flex-col px-2.5">
          <div className="flex justify-between items-center">
          <PageHeader title={title} />
          {headerRight && <div className="header-right">{headerRight}</div>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PanelContainer;
